/**
 * Toast.jsx — Carousel Composer's one-line status pill.
 */

import { useEffect, useState } from 'react';
import { useCarousel } from '../../hooks/useCarouselStore';

export default function Toast() {
  const t = useCarousel((s) => s.toast);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!t) return undefined;
    // the store outlives the page: a toast that already ran its course is not replayed on return
    const left = t.at + t.ms - Date.now();
    if (left <= 0) return undefined;
    setShow(true);
    const id = setTimeout(() => setShow(false), left);
    return () => clearTimeout(id);
  }, [t]);

  return (
    <div className={'toast' + (show ? ' show' : '')} role="status" aria-live="polite">
      {t ? t.msg : ''}
    </div>
  );
}
